module.exports = __webpack_public_path__ + "static/media/steps_c.660332d5.png";